import type { ReactNode } from 'react';

export const symbol_g_mobiledata: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-280q-24 0-42-18t-18-42v-280q0-24 18-42t42-18h266q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H340v280h240v-110H469q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h141q12.75 0 21.38 8.62Q640-492.75 640-480v140q0 24-18 42t-42 18H340Z"
		/>
	</svg>
);
